export function isNavigationItem(item) {
    return 'url' in item && !('items' in item);
}
